var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.332H14.5",
    stroke: "#64748B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.33218C11.7652 2.06697 12.1249 1.91797 12.5 1.91797C12.6857 1.91797 12.8696 1.95455 13.0412 2.02562C13.2128 2.09669 13.3687 2.20086 13.5 2.33218C13.6313 2.4635 13.7355 2.61941 13.8066 2.79099C13.8776 2.96257 13.9142 3.14647 13.9142 3.33218C13.9142 3.5179 13.8776 3.7018 13.8066 3.87338C13.7355 4.04496 13.6313 4.20086 13.5 4.33218L5.16667 12.6655L2.5 13.3322L3.16667 10.6655L11.5 2.33218Z",
    stroke: "#64748B",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a773d25deb15300c44e4be920a775694.svg";
export { ForwardRef as ReactComponent };